const MastercardSvg = ({
  height = 40,
  width = 28,
  viewBox = '0 0 40 28',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <rect x="0.5" y="0.5" width="39" height="27" rx="5.5" fill="white" stroke="#D9D9D9" />
      <path
        d="M25.3447 5.83325C29.6516 5.83343 33.1426 9.43926 33.1426 13.887C33.1425 18.3346 29.6515 21.9405 25.3447 21.9407C23.4135 21.9407 21.6472 21.2137 20.2852 20.0129C18.9232 21.2132 17.1583 21.9406 15.2275 21.9407C10.9206 21.9407 7.42883 18.3347 7.42871 13.887C7.42871 9.43915 10.9205 5.83325 15.2275 5.83325C17.158 5.83331 18.9233 6.55913 20.2852 7.75903C21.6471 6.55867 23.4138 5.83325 25.3447 5.83325Z"
        fill="#ED0006"
      />
      <path
        d="M25.3442 5.83325C29.6513 5.83328 33.1431 9.43916 33.1431 13.887C33.1429 18.3347 29.6512 21.9406 25.3442 21.9407C23.4132 21.9407 21.6477 21.2135 20.2856 20.0129C21.9614 18.5358 23.0258 16.3405 23.0259 13.887C23.0259 11.433 21.9619 9.23618 20.2856 7.75903C21.6476 6.55888 23.4135 5.83325 25.3442 5.83325Z"
        fill="#F9A000"
      />
      <path
        d="M20.2852 7.75903C21.9616 9.23619 23.0264 11.4328 23.0264 13.887C23.0263 16.3407 21.9612 18.5359 20.2852 20.0129C18.6096 18.5359 17.546 16.3403 17.5459 13.887C17.5459 11.4332 18.6092 9.23618 20.2852 7.75903Z"
        fill="#FF5E00"
      />
    </svg>
  );
};
export default MastercardSvg;
